// src/data/playersData.js

const playersData = [
    {
      id: "Peterson",
      name: "XoPeterson",
      division: "Warzone",
      age: 24,
      country: "Trinidad and Tobago",
      joined: "July 19, 2024",
      specialization: "Call of Duty",
      achievements: [
        "Multiple Gold, Silver, and Bronze trophies",
        "Gold winner - Prime Valor 1v1 Tournament"
      ],
      bio: "A 24-year-old from Trinidad and Tobago chasing a lifelong passion for gaming. Competitive since 16, striving for more.",
      socials: {
        tiktok: "https://www.tiktok.com/@xopeterson",
        twitch: "https://www.twitch.tv/xopeterson",
        youtube: "https://youtube.com/@xopeterson",
        twitter: "https://x.com/xopetersonn?s=21"
      }
    },
    {
      id: "Rvssian",
      name: "DemonRvssian",
      division: "Warzone",
      age: 21,
      country: "Guyana",
      joined: "June 1, 2024",
      specialization: "Call of duty",
      achievements: [
        "Tournament champ, content creator"
      ],
      bio: "I Started taking cod seriously when warzone 2019 came out. Started grinding and posting content and made a name for myself and joined Prime Valor to prove my talent to the cod community.",
      socials: {
        tiktok: "https://www.tiktok.com/@demonrvssian",
        twitch: "https://www.twitch.tv/demonrvssian",
        youtube: "https://youtube.com/@Demonrvssian"
      }
    },
    {
      id: "Gxlden",
      name: "yyGxlden",
      division: "Content Creators",
      age: 20,
      country: "Jamaica",
      joined: "",
      specialization: "Call of Duty, Marvel Rivals, Editing",
      achievements: [
        "I'm just a content creator"
      ],
      bio: "Gxlden first started out playing solo games like Uncharted. During Covid, he spent a lot of time on GTA, until eventually migrating to Call of Duty in January of 2021. Since then, he has steadily improved in every aspect of the game, allowing him to be one of the most competitive and hard to kill players today. Focusing heavily on integrating good accuracy into his movement, he has shown the community that movement players should be taken seriously. Through his successful content creation - showing out during his streams, expressing his creativity, and always honing his editing skills - Gxlden has made a name for himself among the Caribbean gaming community, garnering the respect of many of his fans and fellow players alike.",
      socials: {
        tiktok: "https://www.tiktok.com/@yygxlden",
        twitch: "https://www.twitch.tv/yyGxlden",
        youtube: "https://youtube.com/@yyGxlden"
      }
    },
    {
      id: "Potaatochips",
      name: "Potaatochips",
      title: "Partner",
      division: "Content Creators",
      age: 25,
      country: "United Kingdom (Jamaican-born)",
      joined: "",
      specialization: "Resurgence | Rebirth | 1v4 Clutches | High-IQ Plays",
      achievements: [
        "Prime Valor commentator & tournament host",
        "Competed in all JGL CDL style tournaments during MW2 (2022)",
        "Known as 'the teacher' in the community for breaking down plays and mentoring",
        "Viral 1v4s, clutch wipe king, and tactical demon in Resurgence",
        "TikTok & Twitch content creator"
      ],
      bio: "Born with a controller in hand, potaatochips started the journey on COD: Big Red One and Medal of Honor: Rising Sun, passing the sticks with family. But the game got real in MW2019 during lockdown — since then, it's been nothing but elevation. Representing Prime Valor, he's not just a competitor but a voice in the scene, breaking down plays and schooling the community as 'the teacher.' From the sweaty lobbies of MW2 2022's JGL tournaments to dropping calculated wipes on BO6 Rebirth, he's always two steps ahead. Jamaican-bred, UK-based, and always reppin smart plays with vibes.",
      socials: {
        tiktok: "https://www.tiktok.com/@potaatochips.ja",
        twitch: "https://www.twitch.tv/PotaatoChips"
      }
    },
    {
      id: "Liquid",
      name: "liquid",
      division: "CDL Substitute",
      age: 18,
      country: "Trinidad and Tobago",
      joined: "",
      specialization: "fps call of duty",
      achievements: [
        "2x🥇black op 6 champion 1x🥇fortnite champion 4x🥇brawlhalla champion"
      ],
      bio: "I'm just a casual player.",
      socials: {
        tiktok: "https://www.tiktok.com/@de.liquid",
        twitch: "https://www.twitch.tv/de_liquid"
      }
    },
    {
      id: "ChrisWZ",
      name: "ChrisWZ",
      title: "Partner",
      division: "Content Creators",
      age: 24,
      country: "Jamaica",
      joined: "",
      specialization: "FPS games - Call of Duty",
      achievements: [],
      bio: "I used to be more into sports when I was young. Always playing football with friends and cricket, until I was introduced to the handheld game 'GAMEBOY'. The moment I started playing Mario on the gameboy, there was no turning back. I was naturally good at any game I started. I was later introduced to warzone after leaving school by sole classmates, and I have never stopped playing since. Now my aim is to share my experience and laughter with the Caribbean by making content and streaming.",
      socials: {
        tiktok: "https://www.tiktok.com/@chris_.wz",
        twitch: "https://www.twitch.tv/ChrisWZgaming",
        youtube: "https://youtube.com/@ChrisWZ"
      }
    },
    {
      id: "Skrmxx",
      name: "Skrmxx",
      division: "Warzone Substitute",
      age: 20,
      country: "Anguilla",
      joined: "",
      specialization: "FPS Games — Call of Duty, Content Creation",
      achievements: [
        "Aside from a few Tournaments nothing that stands out to him.",
        "Number 1 in Anguilla locally sponsored tourney",
        "3rd primevalor snd tourney",
        "3rd prime valor 1v1 tourney",
        "caribbean held mw3 rebirth tourney 1st"
      ],
      bio: "The well known best Call of duty player from Anguilla, a tiny island bearing only 15,000 People. Skrmxx holds huge dreams aspirations as a gaming content creator But don't be fooled, his Ability to easily adapt and Game skill alone puts him in the Caribbeans top 10. Number 1 in Anguilla locally sponsored tourney, 3rd primevalor snd tourney, 3rd prime valor 1v1 tourney, caribbean held mw3 rebirth tourney 1st.",
      socials: {
        tiktok: "https://www.tiktok.com/@skrmxxlol",
        twitch: "https://www.twitch.tv/Skrmxx",
        youtube: "https://youtube.com/@Skrmxx"
      }
    },
    {
      id: "Jrwyd",
      name: "Jrwyd",
      division: "Content Creators",
      age: 23,
      country: "Jamaica",
      joined: "July 17, 2024",
      specialization: "Call of Duty | CDL",
      achievements: [
        "6x International Champion, 3x Silver, 1x Bronze",
        "1st place debut in the Jamaica Gaming League"
      ],
      bio: "Jr began gaming at the age of 6, with a passion for competition that fully took shape by 16. After discovering the Jamaica Gaming League, he made a powerful debut — winning 1st place in his very first season. Since then, Jr has gone on to compete internationally, earning 4x Gold, 3x Silver, and 1x Bronze trophies across multiple events. Now, he's focused on working with Prime Valor to help put Jamaica on the global gaming map.",
      socials: {
        tiktok: "https://www.tiktok.com/@jrwyd_",
        twitch: "https://www.twitch.tv/Jrwyd_",
        youtube: "https://youtube.com/@jrwyd1",
        twitter: "https://x.com/jrwyd_"
      }
    },
    {
      id: "Shifu",
      name: "Shifu",
      division: "CDL Coach",
      age: 28,
      country: "Jamaica",
      joined: "",
      specialization: "FPS Games — Call of Duty, Content Creation",
      achievements: [
        "Tournament of power NC -DBZ budakai tenkaichi 2 champion -2007",
        "Brother hood of shadow- Mortal Kombat X champion -2016 - MayPen Clarendon",
        "Mortal Kombat X LAN Tourney HWT champion Winner - 2016 -Kingston Jamaica",
        "COD MW3 PrVa Rebirth touney 2024 -2nd Place",
        "COD Bo6 - PrVa 3v3 SnD tourney - 2nd place",
        "COD Bo6 - JGL 3v3 SnD tourney - 2nd Place"
      ],
      bio: "",
      socials: {}
    },
    {
      id: "Slay",
      name: "Slay",
      division: "CDL Substitute",
      age: 22,
      country: "Jamaica",
      joined: "",
      specialization: "Call of Duty || CDL",
      achievements: [
        "JGL Champion",
        "2x Caribbean COD League Champion",
        "JGL MVP",
        "2x International Tournament Winner (AEC League)",
        "Warzone LTM Trios World Record"
      ],
      bio: "Started playing games casually at 14. Started playing Competitive COD in MW2019 and got a series of 2nd place wins in online Jamaican tournaments until the scene died off. Played Warzone for 2 years and achieved a LTM Trios world record. Returned to Competitive COD in the last two months of Vanguard. Started winning in MW2 and didn't stop.",
      socials: {
        tiktok: "https://www.tiktok.com/@slayfpss?is_from_webapp=1&sender_device=pc",
        youtube: "https://youtube.com/@slayfpss?si=lAWjhd9kJ4QNEYZB",
        instagram: "https://www.instagram.com/slayfpss?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
      }
    },
    {
      id: "Ann",
      name: "Ann",
      division: "Female",
      age: 22,
      country: "Trinidad and Tobago",
      joined: "August 18, 2025",
      specialization: "Call of Duty || CDL",
      achievements: [
        "1x Caribbean female 1v1 champ (2022)",
        "2x Caribbean Warzone champ (2025)",
        "1x Prime Valor x JGL 4v4 Caribbean Cup Champ (2025)"
      ],
      bio: "Ann, a seasoned gamer since the age of 4, her journey into the world of competitive Call of Duty began in 2021, where she dedicated herself to honing her skills. 2022 marked a significant milestone for Ann, as she competed in various Z league tournaments. Further solidifying her presence, Ann clinched first place in an all female Caribbean 1v1 tournament in 2022. In 2025, she achieved two victories in a Caribbean Warzone tournament. Now, as a member of Prime Valor, Ann aims to represent Trinidad and Tobago and make her mark in the gaming world.",
      socials: {
        tiktok: "https://www.tiktok.com/@typical_ann"
      }
    },
    {
      id: "Jesse",
      name: "Jesse",
      division: "Female",
      age: 23,
      country: "Trinidad and Tobago",
      joined: "April 10, 2026",
      specialization: "Call of Duty || Warzone, CDL",
      achievements: [
        "Top 7 in TPC Women's Beginner League",
        "2nd place 1v1 tournament (1× silver)",
        "3rd place Trios Rebirth Tournament (1× bronze)"
      ],
      bio: "Been gaming since childhood — started playing COD at around age 7. Got back into it seriously at 15 with BO4. After meeting several Caribbean communities and players, developed a love for creating Warzone content and streaming. Started competing in CDL during MW2 (2022), and got back into competitive play seriously in 2026 — joining an international female team to compete in women's leagues. Placed top 7 in the very first competitive league entered, and is currently pursuing other leagues with hopes of earning a first win and gaining exposure for PrVa and Caribbean gaming.",
      socials: {
        tiktok: "https://www.tiktok.com/@jessetf.xo?_r=1&_t=ZS-95W2ShbjhFn",
        twitch: "https://www.twitch.tv/jessetf_",
        twitter: "https://x.com/jessetf_?s=21&t=44KYU-E98SMm61YZzEAC7g"
      }
    },
    {
      id: "SpltzFps",
      name: "SpltzFps",
      division: "Content Creators",
      age: 23,
      country: "Jamaica",
      joined: "March 9, 2024",
      specialization: "Call of Duty CDL | Warzone | Content Creator",
      achievements: [
        "Still early in the competitive journey, but driven to turn dedication and training into future tournament results."
      ],
      bio: "Gaming started as a simple distraction, then grew into family competitions that pushed me to improve. Those moments motivated me to take my skills to a higher level and shaped me into the gamer I am today. I may consider myself an average player now, but I'm full of potential and driven to unlock the skills that will take me even further.",
      socials: {
        tiktok: "https://www.tiktok.com/@spltzfps"
      }
    },
    {
      id: "JamaicanShifu",
      name: "The Jamaican Shifu",
      title: "Partner",
      division: "Content Creators",
      age: 28,
      country: "Jamaica",
      joined: "",
      specialization: "FPS Games — Call of Duty, Content Creation",
      achievements: [
        "Tournament of power NC -DBZ budakai tenkaichi 2 champion -2007",
        "Brother hood of shadow- Mortal Kombat X champion -2016 - MayPen Clarendon",
        "Mortal Kombat X LAN Tourney HWT champion Winner - 2016 -Kingston Jamaica",
        "COD MW3 PrVa Rebirth touney 2024 -2nd Place",
        "COD Bo6 - PrVa 3v3 SnD tourney - 2nd place",
        "COD Bo6 - JGL 3v3 SnD tourney - 2nd Place"
      ],
      bio: "The Jamaican Shifu is a seasoned gamer and content creator representing Prime Valor. Known for his strategic gameplay and entertaining streams.",
      socials: {
        twitch: "https://m.twitch.tv/JamaicanShifu?desktop-redirect=true",
        instagram: "https://www.instagram.com/thejamaicanshifu/",
        youtube: "https://www.youtube.com/channel/UCT1MQCutkrRGYWDoJWqKngg"
      }
    },
    {
      id: "Goat",
      name: "Goat",
      division: "Warzone",
      age: 18,
      country: "Jamaica",
      joined: "",
      specialization: "Fragger",
      achievements: [
        "Hit Iridescent multiple times"
      ],
      bio: "Goat is a young gamer who started gaming at 7 and is getting into the competitive scene. He is now a member of Prime Valor and aiming to reach his full potential.",
      socials: {
        tiktok: "https://www.tiktok.com/@g_oaat_",
        twitch: "https://www.twitch.tv/goatfpzz"
      }
    },
    {
      id: "Lemo",
      name: "Lemo",
      title: "CEO & Founder",
      division: "Content Creators",
      age: 26,
      country: "Jamaica",
      joined: "March 8",
      specialization: "Call of Duty | CDL | Warzone",
      achievements: [
        "Leader & Founder of Prime Valor",
        "Built Prime Valor into the #1 rising Caribbean gaming organization — hosted multiple successful tournaments, launched the CDL Academy, and is growing one of the most active gaming communities in the region. A trailblazer pushing Caribbean gaming to the world stage."
      ],
      bio: "Driven by vision and fueled by determination, Unc is the founder and leader of Prime Valor. Focused on building the #1 rising Caribbean gaming organization, he leads with passion, consistency, and a willingness to learn every step of the way. Dedicated to pushing the boundaries of what Caribbean gaming can achieve, he continues to shape Prime Valor into not just a team, but a movement.",
      socials: {
        tiktok: "https://www.tiktok.com/@lemo_fps?is_from_webapp=1&sender_device=pc",
        instagram: "https://www.instagram.com/lemo_fps?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
      }
    },
    {
      id: "Ducky",
      name: "Ducky",
      division: "U18",
      age: 14,
      country: "Saint Martin",
      joined: "August 18, 2025",
      specialization: "Call of Duty || Warzone || CDL",
      achievements: ["Currently focused on building skills, streaming presence, and preparing for future competitive opportunities."],
      bio: "My name is ducky I'm a young gamer/streamer that from Saint Martin my dream has always been to go pro or get big in the streaming industry.",
      socials: {
        tiktok: "https://www.tiktok.com/@971ducky?is_from_webapp=1&sender_device=pc"
      }
    },
    {
      id: "Crypty",
      name: "Crypty",
      division: "CDL Team A",
      age: 22,
      country: "Cayman Islands",
      joined: "August 18, 2025",
      specialization: "Call of Duty (LAN) | Rainbow Six Siege (University Circuit)",
      achievements: [
        "3× Tournament Champion",
        "$10,000+ in LAN earnings",
        "£1,000+ in Rainbow Six Siege earnings (University-level)",
        "Multiple podium finishes in regional and international events"
      ],
      bio: "Crypty began gaming at just 10 years old, starting with Call of Duty 4: Modern Warfare. What began as casual fun quickly evolved into a drive for competition, leading him to dominate the LAN tournament scene, where he's earned over $10,000 and claimed 3 championship titles. During university, he extended his competitive reach into Rainbow Six Siege, where he earned over £1,000 representing his school against top-tier talent. Known for high-pressure plays, Crypty has proven himself across multiple esports titles. A veteran in the competitive scene. Now, he's focused on taking his game even further, proudly representing the Cayman Islands on the international stage.",
      socials: {
        tiktok: "https://www.tiktok.com/@jordybap?is_from_webapp=1&sender_device=pc"
      }
    },
    {
      id: "Chozendontmiss",
      name: "Chozendontmiss",
      division: "CDL Team A",
      age: 23,
      country: "Cayman Islands",
      joined: "",
      specialization: "Call of Duty || CDL",
      achievements: [
        "2× LAN Champion",
        "2× Gold Medal Finishes",
        "4× Bronze Medal Finishes",
        "Multiple Top 4 Placements",
        "$7,000+ USD in Prize Earnings"
      ],
      bio: "Chozendontmiss began competing professionally in 2019, driven by a passion for esports and the goal of taking his talent to the international stage. Specializing in Call of Duty, he has consistently proven himself in high pressure competitive environments, earning recognition through strong LAN performances and podium finishes. With ambitions of moving to the United States next season to compete in Challengers and go pro, Chozendontmiss is focused on elevating his career while proudly representing the Cayman Islands and the Caribbean as a whole on the global esports stage. Known for his determination, consistency, and competitive mindset, he continues to push toward becoming one of the region's standout players.",
      socials: {}
    },
    {
      id: "Tank5",
      name: "Tank5",
      division: "Content Creators",
      age: 20,
      country: "Jamaica",
      joined: "May 17, 2025",
      specialization: "Any Game I Touch || Content Creator",
      achievements: ["30+ FreeFire Tournaments won", "Esports player"],
      bio: "Tank does not play games for fun. As soon as I find a game I like I already turn it into a competition to see how good I can get aiming to be above average. After fully mastering free fire, winning countless tournaments in the Caribbean and attracting hundreds of thousands of people to his insane skills, Tank plans on moving on to different games to work towards.",
      socials: {
        tiktok: "https://www.tiktok.com/@realtank5",
        twitch: "https://www.twitch.tv/realtank5_",
        youtube: "https://youtube.com/@TANK5"
      }
    },
  ];

  export default playersData;
